import React, { Component } from 'react';
import T from 'prop-types';
import ReactPopover from 'react-popover';
// styles
import './Popover.mod.css';

class Popover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.initialOpen
    };
  }

  componentWillReceiveProps({ initialOpen }) {
    initialOpen &&
      this.setState({
        isOpen: initialOpen
      });
  }

  componentDidMount() {
    const { trigger } = this.props;
    if (trigger === 'hover') {
      this.target.addEventListener('mouseenter', this.onTargetMouseenter);
      this.target.addEventListener('mouseleave', this.onTargetMouseleave);
    }
    if (trigger === 'click') {
      this.target.addEventListener('click', this.togglePopover);
    }
  }

  componentWillUnmount() {
    this.target.removeEventListener('mouseenter', this.openPopover);
    this.target.removeEventListener('mouseleave', this.closePopover);
    this.target.removeEventListener('click', this.togglePopover);
  }

  onTargetMouseenter = () => {
    clearTimeout(this.closeTimeout);
    this.openTimeout = setTimeout(this.openPopover, 200);
  };

  onTargetMouseleave = () => {
    clearTimeout(this.openTimeout);
    this.closeTimeout = setTimeout(this.closePopover, 200);
  };

  openPopover = () => {
    this.setState({ isOpen: true });
  };

  closePopover = () => {
    this.setState({ isOpen: false });
  };

  togglePopover = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  render() {
    const { children, body, trigger, ...otherProps } = this.props;
    const { isOpen } = this.state;

    const bodyProps =
      trigger === 'hover'
        ? {
            onMouseEnter: this.onTargetMouseenter,
            onMouseLeave: this.onTargetMouseleave
          }
        : {};

    return (
      <ReactPopover
        isOpen={isOpen}
        body={<div {...bodyProps}>{body}</div>}
        onOuterAction={this.closePopover}
        tipSize={10}
        {...otherProps}
      >
        <div ref={ref => (this.target = ref)}>{children}</div>
      </ReactPopover>
    );
  }
}

Popover.defaultProps = {
  initialOpen: false,
  trigger: 'hover'
};

Popover.propTypes = {
  initialOpen: T.bool,
  body: T.oneOfType([T.node, T.element]).isRequired,
  trigger: T.oneOf(['click', 'hover']).isRequired
};

export default Popover;



// WEBPACK FOOTER //
// ./src/components/Popover/Popover.jsx